import React from 'react'

import { faqAleloTudo, faqAleloPOD } from 'pages/DetailProduct/data/faq.js'

import { podDetail, tudoDetail } from 'constants/card-details'
import { colors } from 'styles/colors'
import { useMobile } from 'utils/mobile'

import { Container, Desc, Header } from './style'
import {
    Content,
    List,
    AccordionText,
    Title,
    StyledAccordion
} from './DetailProductFAQ.style'

const DetailProductFAQ = ({ type, data }) => {
    const info = {
        TUDO: tudoDetail,
        POD: podDetail
    }

    const faqData = type === 'TUDO' ? faqAleloTudo : faqAleloPOD
    const product = { ...data, ...info[type] }

    const color = type === 'TUDO' ? colors.darkGreen : colors.deepPurple

    const mobile = useMobile()

    return (
        <Container>
            <Content>
                <Header>
                    <Title $color={color}>Perguntas frequentes</Title>
                    <Desc>
                        Veja aqui as principais dúvidas sobre o cartão{' '}
                        {product.name}
                    </Desc>
                </Header>
                <List>
                    {faqData.map((item, index) => (
                        <StyledAccordion
                            showArrow={mobile}
                            key={index}
                            title={item.question}
                            color={color}
                        >
                            <AccordionText>{item.answer}</AccordionText>
                        </StyledAccordion>
                    ))}
                </List>
            </Content>
        </Container>
    )
}

export default DetailProductFAQ
